import { memo } from 'react'
import { Text } from '@leroy-merlin-br/backyard-react-ui'

import { Notification } from 'checkout/components/Notification'

import * as S from './styled'

const CouponAvailable = () => (
  <S.Wrapper>
    <Notification>
      <Text size="kilo" noMargin>
        Possui um{' '}
        <Text as="strong" size="kilo" noMargin bold>cupom de desconto</Text> ou{' '}
        <Text as="strong" size="kilo" noMargin bold>vale-compras fidelidade</Text>?{' '}
        Aplique na etapa de pagamento.
      </Text>
    </Notification>
  </S.Wrapper>
)

export default memo(CouponAvailable)
